var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.skinClasses],staticStyle:{"height":"100vh"},attrs:{"id":"app"}},[(_vm.loaded)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }